import React, {useContext} from 'react';
import InstallerContext from "@/context/InstallerContext";

const LoginProviderCard = ({id, name, description, selected}) => {
  const {setLoginProvider} = useContext(InstallerContext)
  
  return (
      <div
          onClick={() => setLoginProvider(id)}
          className={`login-provider-card ${selected && 'active'}`}
      >
        {name}
        <p className="text-sm text-gray-500">{description}</p>
      </div>
  );
};

export default LoginProviderCard;